export interface CommitMessageJSON {
  body?: string;
  footer?: string;
  subject?: string;
}
